
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Helper function to generate task and list card classes
export function getCardClasses(isActive: boolean, additionalClasses?: string) {
  return cn(
    "task-card p-3 flex items-center justify-between cursor-pointer rounded-lg overflow-visible",
    isActive && "task-card-active",
    additionalClasses
  )
}

// Helper for active indicator badge
export function getActiveBadgeClasses(type: 'task' | 'list' = 'task') {
  return "absolute -top-2.5 right-10 bg-green-500 text-white text-xs px-2.5 py-0.5 rounded-full shadow-sm z-10"
}
